export default "__VITE_ASSET__BszJTGD4__"